import { RGBColor } from "react-color";

export const rgbaToHex = (color: RGBColor): string => {
    const { r, g, b, a = 1 } = color;
    const toHex = (value: number) => {
        const hex = Math.round(value).toString(16);
        return hex.length === 1 ? '0' + hex : hex;
    };

    const alpha = Math.round(a * 255);
    return `#${toHex(r)}${toHex(g)}${toHex(b)}${alpha < 255 ? toHex(alpha) : ''}`;
};